var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarker02 = function SvgMarker02(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00066 10.8002C6.00066 10.8002 9.75718 7.46106 9.75718 4.95672C9.75718 2.88205 8.07533 1.2002 6.00066 1.2002C3.92599 1.2002 2.24414 2.88205 2.24414 4.95672C2.24414 7.46106 6.00066 10.8002 6.00066 10.8002Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20082 4.80027C7.20082 5.46301 6.66356 6.00027 6.00082 6.00027C5.33807 6.00027 4.80082 5.46301 4.80082 4.80027C4.80082 4.13753 5.33807 3.60027 6.00082 3.60027C6.66356 3.60027 7.20082 4.13753 7.20082 4.80027Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00066 10.8002C6.00066 10.8002 9.75718 7.46106 9.75718 4.95672C9.75718 2.88205 8.07533 1.2002 6.00066 1.2002C3.92599 1.2002 2.24414 2.88205 2.24414 4.95672C2.24414 7.46106 6.00066 10.8002 6.00066 10.8002Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20082 4.80027C7.20082 5.46301 6.66356 6.00027 6.00082 6.00027C5.33807 6.00027 4.80082 5.46301 4.80082 4.80027C4.80082 4.13753 5.33807 3.60027 6.00082 3.60027C6.66356 3.60027 7.20082 4.13753 7.20082 4.80027Z",
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarker02);
export default ForwardRef;